import Link from "next/link";
import type { MarketingLink } from "../marketing.type";

export interface RelatedCard extends MarketingLink {
  description: string;
}

interface RelatedCardsProps {
  cards: RelatedCard[];
}

// "Related" internal-link cards at the foot of a 2.0 page.
const RelatedCards = ({ cards }: RelatedCardsProps) => (
  <div className="grid gap-4 sm:grid-cols-2 xl:grid-cols-4">
    {cards.map((card) => (
      <Link
        key={card.route}
        href={card.route}
        className="block rounded-[18px] border border-line bg-white p-5 transition-colors hover:border-primary"
      >
        <span className="mb-1 block text-base font-bold">{card.label}</span>
        <span className="block text-[14.5px] leading-[1.45] text-ink-muted">
          {card.description}
        </span>
      </Link>
    ))}
  </div>
);

export default RelatedCards;
